import { ITeam } from '~/store/user/types';
import getChannelDataItem from './getChannelDataItem';

const getChannelTeams = (data?: string | null): ITeam[] => {
  const teams = getChannelDataItem(data, 'teams');
  if (Array.isArray(teams)) {
    return teams;
  }

  const team = getChannelDataItem(data, 'team');
  return team ? [team] : [];
};

export default getChannelTeams;
